import { generateUrlWithQueryParameter, REMOVE_FALSY } from '@helpers/url';

export default async function getAlgoliaFilterData({
  preview,
  query = '',
  channel = 'site',
}: {
  preview?: boolean;
  query?: string;
  channel?: string;
} = {}): Promise<any> {
  const queryParam = encodeURIComponent(query.toLocaleLowerCase());

  const url = generateUrlWithQueryParameter(
    `/api/datocms/search/term/${channel}/${queryParam}`,
    {
      preview,
    },
    REMOVE_FALSY
  );

  const response = await fetch(url);
  return response.json();
}
